import SkConfig from '../config';
import { Http } from '@samknows/utils';

const API_ENDPOINT = SkConfig.api.zeus;

/* eslint-disable @typescript-eslint/no-explicit-any */ // TODO [WEBPLAT-151] types in this file are all `any`

// TODO Please add types in this file to replace `any` if you touch it!
export default {
  getData(page = '1', search = {}, filter = {}, perPage = '50') {
    const params = {
      page,
      ...search,
      ...filter,
      per_page: perPage
    };
    return Http.get<any>(API_ENDPOINT, `/signups`, params, {
      newErrors: true
    });
  },

  get(type: string, params?: any) {
    return Http.get<any>(API_ENDPOINT, `/${type}`, params, {
      newErrors: true
    });
  },

  update<T = unknown>(type: string, data: any): Promise<T> {
    return Http.request<T>(`${API_ENDPOINT}/${type}`, {
      method: 'PUT',
      newErrors: true,
      body: JSON.stringify(data)
    });
  },
  create(type: string, data?: any) {
    return Http.request<any>(`${API_ENDPOINT}/${type}`, {
      method: 'POST',
      body: JSON.stringify(data),
      newErrors: true,
      getFullResponse: true
    }).then((res) => ({ location: res.headers.get('Location') }));
  },
  delete(type: string) {
    return Http.request<any>(`${API_ENDPOINT}/${type}`, {
      method: 'DELETE',
      newErrors: true
    });
  }
};
